import { useEffect, useState } from "react";
import { LogoMark } from "./Logo";
import { scrollToSection, scrollToTop } from "../lib/scroll";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    scrollToSection(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled
          ? "border-line bg-paper/85 shadow-[0_8px_30px_-18px_rgba(11,42,38,0.25)] backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a
          href="/"
          data-testid="navbar-logo"
          onClick={(e) => {
            e.preventDefault();
            scrollToTop();
          }}
          className="flex items-center gap-2.5"
        >
          <LogoMark className="h-9 w-9" />
          <span className="font-display text-xl font-semibold tracking-tight">AssisDent</span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          <a
            href="#about"
            onClick={go("about")}
            data-testid="nav-about-link"
            className="text-sm font-medium text-ink/60 transition-colors hover:text-ink"
          >
            About us
          </a>
        </div>
        <button
          onClick={() => scrollToSection("register")}
          data-testid="nav-book-cta"
          className="group inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white shadow-[0_10px_25px_-10px_rgba(13,148,136,0.6)] transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-brand-deep"
        >
          Book now
        </button>
      </nav>
    </header>
  );
};
